import { gql } from "@apollo/client";

export const GENERATE_BAT_HISTORY = gql`
  query GetBatHistory($cId: ID!, $pId: ID!) {
    getBatHistory(cId: $cId, pId: $pId) {
      fileName
      size
      lastModified
    }
  }
`;
